// App.js
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './Components/LoginPage';
import Dashboard from './Components/Dashboard';
import Home from './Components/Home';
import Register from './Components/Register';
import SubVakairs from './Components/SubVakairs';
import RelationShips from './Components/RelationShips';
import Member from './Components/Member';
import EventRegistration from './Components/EventRegistration';
import Transactions from './Components/Transactions';
import VakairaMembersDownload from './Components/AllReports';
import TransactionReport from './Components/TransactionReport';
import RegisterForm from './Components/RegisterForm';
import FemaleMember from './Components/FemaleMember';
import OtherParticipations from './Components/OtherParticipations';
import Santha from './Components/Santha';
import ExpenseMaster from './Components/ExpenseMaster';
import ExpenseForm from './Components/ExpenseForm';
import SanthaMaster from './Components/SanthaMaster';
import SanthaLive from './Components/SanthaLive';
import SanthaDonation from './Components/SanthaDonation';
import Attendance from './Components/Attendance';
import AttendanceList from './Components/AttendanceList';
import PreConList from './Components/preconlist';

import ArchiveList from './Components/ArchiveList';
import Visitor from './Components/Visitor';



function App() {
  return (
    <Router>
      <Routes>

        <Route path="/" element={<LoginPage />} />
        <Route path="/signup" element={<RegisterForm />} />
        <Route path="/dashboard" element={<Dashboard />}>
          {/* Use relative paths for nested routes */}
          <Route index element={<Home />} />
          <Route path="register" element={<Register />} />
          <Route path="subvakairs" element={<SubVakairs />} />
          <Route path="relationship" element={<RelationShips />} />
          <Route path="member" element={<Member />} />
          <Route path="femalemember" element={<FemaleMember />} />
          <Route path="otherparticipations" element={<OtherParticipations />} />
          <Route path="event" element={<EventRegistration />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="santha" element={<Santha />} />
          <Route path='expense-master' element={<ExpenseMaster />} />
          <Route path='expense-form' element={<ExpenseForm />} />
          <Route path='santhamaster' element={<SanthaMaster />} />
          <Route path="allreports" element={<VakairaMembersDownload />} />
          <Route path="report" element={<TransactionReport />} />
          <Route path="santhalive" element={<SanthaLive />} />
          <Route path='donation' element={<SanthaDonation />} />

          <Route path='attendance' element={<Attendance />} />
          <Route path='/dashboard/atten-list' element={<AttendanceList />} />
          <Route path='rqlist' element={<ArchiveList />} />
          <Route path='visitor' element={<Visitor />} />
          <Route path='/dashboard/preconlist' element={<PreConList />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
